import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/blogs/[...iden]/components/BlogDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/ArrowLabel.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/PopularArticles/components/ArticlesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/components/PopularServices/components/ServicesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/analytics/TrackedCtaLink.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/components/animations/ScrollReveal.tsx");
